import { render, staticRenderFns } from "./GetPackages.vue?vue&type=template&id=5e22a2b8&"
import script from "./GetPackages.vue?vue&type=script&lang=js&"
export * from "./GetPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports